import type { PriceListMtrRowData } from 'gql/graphql';
import { ContractStatusEnum } from 'gql/graphql';
import { Button, ContextMenu, IconKebab, cnMixSpace } from 'uikit';

import { useCallback, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface IPriceListMtrRowMenu {
    row: PriceListMtrRowData;
    contractStatus: ContractStatusEnum | undefined;
}

const disabledForEdit = ['CONTRACT_CONDITION', 'ADDITIONAL_CONDITION'];

export const PriceListMtrRowMenu = ({ row, contractStatus }: IPriceListMtrRowMenu) => {
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef(null);
    const navigate = useNavigate();

    const handleOnClick = useCallback(() => {
        setIsOpen((prevState) => !prevState);
    }, []);

    const handleItemClick = (): any => {
        navigate(`editMtr/${row.id}`, { replace: true });

        handleOnClick();
    };

    const isDisabled = useMemo(() => disabledForEdit.includes(row.status), [row.status]);
    const isContractStatusWork = contractStatus === ContractStatusEnum.InImplementation;

    const disabled = isDisabled || !isContractStatusWork;

    return (
        <>
            <Button
                className={cnMixSpace({ mR: 'l' })}
                iconLeft={IconKebab}
                onlyIcon
                view={disabled ? 'primary' : 'clear'}
                size="xs"
                ref={ref}
                onClick={handleOnClick}
                disabled={disabled}
            />
            <ContextMenu
                isOpen={isOpen}
                items={['Редактировать']}
                getItemLabel={(item) => item}
                anchorRef={ref}
                direction="downStartLeft"
                getItemOnClick={handleItemClick}
                onClickOutside={handleOnClick}
            />
        </>
    );
};

PriceListMtrRowMenu.displayName = 'PriceListMtrRowMenu';
